export default "__VITE_ASSET__575e9dc9__"